import { Component, OnInit } from '@angular/core';
import { IFormGroup } from '@shared-libs/interfaces';
import { Action, NavigationDataKey } from '@shared-libs/enums';
import { NavigationService } from '@shared-services/navigation.service';
import { formIsValid } from '@shared-libs/helpers';
import { ILessonForm, LessonFormFactory } from '@internal-factories/forms/lesson-form.factory';
import { ILesson } from '@internal-models/lesson.model';

@Component({
	selector: 'lesson-component',
	templateUrl: 'lesson.component.html',
	styleUrls: ['./lesson.component.scss'],
})
export class LessonComponent implements OnInit {
	public action: Action;
	public lesson: ILesson;
	public lessonIndex: number;
	public lessonForm: IFormGroup<ILessonForm>;

	constructor(private readonly navigationService: NavigationService) {}

	public ngOnInit(): void {
		this.action = this.navigationService.getNavigationData(NavigationDataKey.action);
		this.lesson = this.navigationService.getNavigationData(NavigationDataKey.lesson);
		this.lessonIndex = this.navigationService.getNavigationData(NavigationDataKey.lessonIndex);
		this.initializeForm(this.lesson);
	}

	public initializeForm(lesson: ILesson): void {
		this.lessonForm = LessonFormFactory.create(lesson);
	}

	public createLesson() {
		if (formIsValid(this.lessonForm, LessonComponent)) {
			const lesson = LessonFormFactory.getValue(this.lessonForm);
			this.navigationService.navigateBack({ resultingAction: Action.CREATE, lesson });
		}
	}

	public deleteLesson() {
		const lesson = this.lesson;
		const lessonIndex = this.lessonIndex;
		this.navigationService.navigateBack({ resultingAction: Action.DELETE, lesson, lessonIndex });
	}

	public updateLesson() {
		if (formIsValid(this.lessonForm, LessonComponent)) {
			const lesson = LessonFormFactory.getValue(this.lessonForm);
			const lessonIndex = this.lessonIndex;
			this.navigationService.navigateBack({ resultingAction: Action.UPDATE, lesson, lessonIndex });
		}
	}
}
